/* eslint-disable class-methods-use-this, import/no-extraneous-dependencies */
import useJwt from '@/auth/jwt/useJwt'

export default class ChatFollowService {
  list(filters, page = 0) {
    let params = {}
    if (filters !== undefined) {
      params = Object.fromEntries(Object.entries(filters).filter(filter => filter[1] !== '' && filter[1] !== 'all'))
    }

    params.order_by = params.sortBy + (params.sortDesc ? ' DESC' : '')
    delete params.sortDesc
    delete params.sortBy

    return useJwt.get(`/users?page=${page}`, params)
  }

  // eslint-disable-next-line class-methods-use-this
  sendFile(formData) {
    return useJwt.post('/chat-follow/import', {}, formData)
  }

  saveNewConductRecommendation(chatId, conductRecommendation) {
    return useJwt.post('/chat-follow/conduct-recommendation', {}, {
      chat_id: chatId,
      conduct_recommendation: conductRecommendation,
    })
  }

  loadUser(userId) {
    return useJwt.get('/chat-follow/load-user', { user_id: userId })
  }

  saveNewIssueText(chatId, issueText) {
    return useJwt.post('/chat-follow/issue-text', {}, {
      chat_id: chatId,
      issue_text: issueText,
    })
  }

  setLeadProcessed(chatId) {
    return useJwt.post('/chat-follow/set-lead-processed', {}, {
      chat_id: chatId,
    })
  }

  saveNewIssueTextWhats(chatId, issueText) {
    return useJwt.post('/chat-follow/issue-text-whats', {}, {
      chat_id: chatId,
      issue_text: issueText,
    })
  }

  sendIssueAnswer(chatId, issueText, userId, type, list) {
    return useJwt.post('/chat-follow/issue-answer', {}, {
      chat_id: chatId,
      user_id: userId,
      issue_text: issueText,
      type,
      list,
    })
  }

  removeChat(chatId) {
    return useJwt.delete(`/chat-follow/${chatId}`)
  }

  getChat(chatId) {
    return useJwt.get('/chat-follow/chat', { chat_id: chatId })
  }

  getFiles() {
    return useJwt.get('/chat-follow/files', {})
  }

  getSupportingData(userId) {
    return useJwt.get('/chat-follow/supporting-data', { user_id: userId })
  }

  setApprovedConductRecommendation(chatId, userId, status) {
    return useJwt.post('/chat-follow/set-approved-conduct-recommendation', { chat_id: chatId, user_id: userId, status })
  }

  // eslint-disable-next-line class-methods-use-this
  getSettings() {
    return useJwt.get('/chat-follow/settings', {}, {})
  }

  // eslint-disable-next-line class-methods-use-this
  postProcessChosen(formData) {
    return useJwt.post('/chat-follow/process-chosen', {}, formData)
  }
}
